import { z } from 'zod';

import { realtimeClient } from '@/lib/api-client';
import { ApiError } from '@/lib/errors';

const assistantTicketSchema = z.object({
  ticket: z.string().min(1),
  conversationId: z.string().min(1),
  wsPath: z.string().min(1),
});

export type AssistantTicket = z.infer<typeof assistantTicketSchema>;

export const assistantService = {
  async mintTicket(sessionId: string): Promise<AssistantTicket> {
    const { data } = await realtimeClient.post<{ data: unknown }>(
      `/sessions/${sessionId}/assistant/ticket`,
    );
    const parsed = assistantTicketSchema.safeParse(data.data);
    if (!parsed.success) {
      throw new ApiError({
        status: 0,
        code: 'SHAPE_MISMATCH',
        message: 'assistantService.mintTicket: bad response shape',
      });
    }
    return parsed.data;
  },
} as const;
